export default __webpack_public_path__ + "static/media/sv.b7d8d32f.png";